import React from 'react';
export function Transformation() {
  return <section className="py-16 md:py-24 px-4 bg-[#FDFBF9]" data-id="element-227">
      <div className="max-w-3xl mx-auto" data-id="element-228">
        <div className="text-center mb-12" data-id="element-229">
          <h2 className="text-3xl md:text-4xl font-bold text-[#2E2E2E]" data-id="element-230">
            Lo que cambia cuando tenés un plan
          </h2>
        </div>

        <div className="space-y-6 text-[#2E2E2E]/80 text-base md:text-lg leading-relaxed" data-id="element-231">
          <p data-id="element-232">
            La cena deja de ser el momento más tenso del día. Sabés qué vas a
            cocinar, tenés los ingredientes, y no dependés de la improvisación
            de último momento. Eso solo ya baja la fricción.
          </p>

          <p data-id="element-233">
            Los chicos empiezan a confiar en la previsibilidad. Cuando saben qué
            esperar (y tienen algo de control), la resistencia baja. No
            desaparece, pero se vuelve manejable.
          </p>

          <p data-id="element-234">
            Vos terminás el día con menos desgaste mental. No es magia, es
            estructura. Y la estructura, cuando está bien pensada, libera
            energía para lo que importa.
          </p>
        </div>
      </div>
    </section>;
}